import queryString from "query-string";

import { ECONTRACT } from "constants/actionTypes";

import { getLivestockSaleId } from "lib/navigation";
import { serializeEContract } from "lib/serializers/eContracts";

import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";

const urlCreator = ({ action, changesSince, livestockSaleId, id } = {}) => {
  return queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction(
      `/v2/econtracts/${livestockSaleId}/`,
      id,
      action,
    ),
    query: {
      changesSince,
    },
  });
};

export const EContactAction = offlineActionCreator(
  ECONTRACT,
  serializeEContract,
  urlCreator,
  true,
);

EContactAction.void = eContractId => {
  return {
    type: ECONTRACT.VOID.REQUEST,
    eContractId,
    meta: {
      offline: {
        effect: {
          url: urlCreator({
            id: eContractId,
            action: "void",
            livestockSaleId: getLivestockSaleId(),
          }),
          method: "POST",
        },
        commit: {
          type: ECONTRACT.VOID.SUCCESS,
        },
        rollback: {
          type: ECONTRACT.VOID.FAILURE,
        },
      },
    },
  };
};
